import { useHistory } from 'react-router-dom'
import React from 'react'
import { getCookie } from '../common/cookie'
import { courseName } from '../common/utils'
import { FormattedMessage, useIntl } from 'react-intl'
import CardImageShow from '../CertShow/CertShow'
import imageFiles from '../certImages.json'

import styles from './Cert.module.css'

const getCourseUrl = (certCompactName) => {
  const language = getCookie('language')
  if (certCompactName.indexOf('Mermaid') > -1) {
    return `/course/Mermaid/${language}?course=${certCompactName}`
  }
  return `/course/${certCompactName}/${language}`
}

const defaultImage = '-1'
const getImageFile = (cert) => {
  const match = imageFiles.filter((i) => i.id === '' + cert.certificationNumber)
  return cert.certificationNumber === 1 && cert.certificationName !== 'Divemaster' ? defaultImage : match[0].file
}

const LightenCert = ({ cert, type }) => {
  const certCompactName = courseName[cert.certificationName]
  const { formatMessage } = useIntl()
  const { push } = useHistory()

  const getCertType = (type) => {
    switch (type) {
      case 'scuba':
        return formatMessage({ id: 'certlist-scuba' })
      case 'freediver':
        return formatMessage({ id: 'certlist-freediver' })
      case 'mermaid':
        return formatMessage({ id: 'certlist-mermaid' })
      default:
        return null
    }
  }

  return (
    <div className={styles['card-wrapper']} onClick={() => push(getCourseUrl(certCompactName))}>
      <div className={styles['diver_card__bg']}>
        <CardImageShow path={`certs/cert_${getImageFile(cert)}.jpg`} cert={cert} />
        <div className={styles.mask}>
          <img src={require(`../../assets/images/common/lighten.png`)} className={styles.star} alt="Highlight" />
        </div>
      </div>
      <div className={styles.title}>
        <FormattedMessage id="certlist-nextCard" /> {getCertType(type)}
      </div>
    </div>
  )
}

export default LightenCert
